// src/features/hotels-overview/components/MiniSparkline.tsx
//
// A tiny inline trend line for the «Llegadas por día» column (mockup 09).
import React from 'react';
import { useTheme } from '@mui/material';

interface MiniSparklineProps {
  points: number[];
  color?: string;
}

export const MiniSparkline: React.FC<MiniSparklineProps> = ({ points, color }) => {
  const theme = useTheme();
  const stroke = color ?? theme.palette.dataAccent.dark;
  if (!points.length) return null;
  const w = 72;
  const h = 20;
  const max = Math.max(...points, 1);
  const step = points.length > 1 ? w / (points.length - 1) : 0;
  const coords = points.map((p, i) => [i * step, h - (p / max) * h]);
  const line = coords.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ');

  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} style={{ display: 'block' }}>
      <path d={line} fill="none" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
